"use client"
import { useState, useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import emailjs from 'emailjs-com';

function useClient() {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [form, setForm] = useState({
        nom: '',
        prenom: '',
        email: '',
        telephone: '',
        message: '',
        website: '' // Honeypot field
    });

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setForm(prev => ({ ...prev, [name]: value }));
    }, []);

    const handleSubmit = useCallback(async (e) => {
        e.preventDefault();

        // Vérification du honeypot - si rempli, c'est un bot
        if (form.website) {
            // Bot détecté via honeypot — ne rien faire
            alert('Message envoyé avec succès');
            setForm({
                nom: '',
                prenom: '',
                email: '',
                telephone: '',
                message: '',
                website: ''
            });
            return;
        }

        // Vérification reCAPTCHA v3
        if (!executeRecaptcha) {
            alert('Veuillez patienter un instant et réessayer');
            return;
        }

        try {
            // Générer le token reCAPTCHA
            const recaptchaToken = await executeRecaptcha('contact_form');

            const templateParams = {
                nom: form.nom,
                prenom: form.prenom,
                email: form.email,
                telephone: form.telephone,
                message: form.message,
                from_email: form.email,
                recaptcha_token: recaptchaToken
            };

            emailjs.send('service_lcvg8al', 'template_3ns09af', templateParams, 'NPfHtgot0urcyvNSa')
                .then(() => {
                    alert('Message envoyé avec succès');
                    setForm({
                        nom: '',
                        prenom: '',
                        email: '',
                        telephone: '',
                        message: '',
                        website: ''
                    });
                }, (error) => {
                    console.error("Erreur lors de l'envoi :", error);
                    alert('Erreur lors de l\'envoi du message');
                });
        } catch (error) {
            console.error('Erreur reCAPTCHA:', error);
            alert('Erreur de vérification. Veuillez réessayer.');
        }
    }, [form, executeRecaptcha]);

    return {
        form,
        handleChange,
        handleSubmit
    };
}

export default useClient;
